export default __webpack_public_path__ + "static/media/logo.e0b97036.svg";